module.exports = __webpack_public_path__ + "static/savinglives_card_img5@2x-ade0f411d8c347ec0d5e1dd58765ca44.jpg";